import(/* webpackMode: "eager" */ "/app/apps/web/src/app/(pages)/(main)/history/layout.tsx");
